import { z } from 'zod';

/**
 * Common option schema used by both SingleChoice and Checkbox questions
 */
export const OptionSchema = z.object({
  value: z.string().min(1, 'Empty option is not allowed')
});

export type Option = z.infer<typeof OptionSchema>;

/**
 * Base schema for all question types
 */
export const BaseQuestionSchema = z.object({
  label: z.string().min(1, 'Question is required'),
  isRequired: z.boolean(),
  isDeleted: z.boolean().optional()
});

export type BaseQuestionFormValues = z.infer<typeof BaseQuestionSchema>;

/**
 * Helper function to create options schema with custom minimum requirement
 * @param minOptions - Minimum number of options required
 * @param errorMessage - Custom error message for minimum options validation
 */
export const getOptionsSchema = (
  minOptions: number,
  errorMessage: string
): z.ZodEffects<z.ZodArray<typeof OptionSchema, 'many'>, string[], Option[]> =>
  z
    .array(OptionSchema)
    .min(minOptions, errorMessage)
    .transform((opts) => opts.map((opt) => opt.value));
